import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { WebSessionRegistry } from '../web-auth/web-session.registry';
import { WebTokenBridge } from '../web-auth/web-token.bridge';
import { AuthService } from './auth.service';
import { AuthGuard } from './permission.service';

/** Ent (Şirket) rotasının org yüzeyindeki karşılığı; karşılığı olmayan rota Organizasyon ana sayfasına gider. */
const ORG_COUNTERPARTS: readonly [RegExp, string][] = [
    [/^\/templates\/membership(?:[/?#]|$)/, '/org/membership-settings'],
    [/^\/templates\/consent-documents(?:[/?#]|$)/, '/org/consent-documents'],
    [/^\/pages\/company-profile(?:[/?#]|$)/, '/org/settings'],
    [/^\/info\/security(?:[/?#]|$)/, '/org/settings/devices'],
    [/^\/pages\/help(?:[/?#]|$)/, '/org/help']
];

export function orgCounterpart(url: string): string {
    return ORG_COUNTERPARTS.find(([re]) => re.test(url))?.[1] ?? '/org';
}

/**
 * Ent rotalarının kapısı (AuthGuard'ın önünde). Yalnız org web oturumu (scp=org; Keycloak/ent token'ı yok) varken ent rotasına
 * gidilirse giriş sayfasına sessizce düşülmez: karşılığı olan /org sayfasına yönlenir. Öteki her durumda AuthGuard aynen çalışır.
 * Org kaydı okunamazsa (kasa hatası) AuthGuard'a bırakılır: eski davranış.
 * Admin web oturumunda (scp=admin) şirket uçları 403 döner: şirket rotası /admin'e yönlenir.
 */
export const entRouteGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const auth = inject(AuthService);
    const reg = inject(WebSessionRegistry);
    const router = inject(Router);
    const authGuard = inject(AuthGuard);
    const bridge = inject(WebTokenBridge);
    await auth.whenSessionReady();
    if (bridge.active() === 'admin') return router.parseUrl('/admin');
    if (!auth.getAccessToken()) {
        let org = reg.current('org');
        if (!org) {
            try {
                org = await reg.resume('org');
            } catch (e) {
                console.warn('[ent-route] org oturumu okunamadı; giriş kapısına bırakılıyor', e);
            }
        }
        if (org) return router.parseUrl(orgCounterpart(state?.url ?? ''));
    }
    // Promise içinden Observable döndürülmez (yönlendirici onu değer sayar): AuthGuard sonucu beklenir.
    return firstValueFrom(authGuard.canActivate(route, state));
};
